import { render, staticRenderFns } from "./images-m.vue?vue&type=template&id=b592ef12&scoped=true"
import script from "./images-m.vue?vue&type=script&lang=js"
export * from "./images-m.vue?vue&type=script&lang=js"
import style0 from "./images-m.vue?vue&type=style&index=0&id=b592ef12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b592ef12",
  null
  
)

export default component.exports